module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/233-transnistria-7b8c2a586800d536490e66977ba9eee7.svg";